/* eslint-disable react/require-default-props */
/* eslint-disable react/destructuring-assignment */
import { EntityTypeType, UnitOfMeasureType } from '../../../../../../../../models/core/cache.type';
import { Action } from '../../../../../../../../models/core/core.type';
import {
  ProposalServiceQuotationType,
  ProposalServiceType,
} from '../../../../../../../../models/core/proposals.type';
import ServiceQuotationSummary from '../../../../../components/ServiceQuotationSummary';

type ServiceQuotationEditorProps = {
  data: ProposalServiceType;
  isEdit?: boolean;
  sharedResidues?: string[];
  referenceData?: {
    entityTypeData?: EntityTypeType[];
    unitOfMeasures: UnitOfMeasureType[];
  };
  zIndex?: number;
  initialQuotationItem?: ProposalServiceQuotationType | null;
  initialQuotationTab?: 'Cotacao' | 'Tolerancias';
  autoOpenQuotationModal?: boolean;
  onChange?: (item: ProposalServiceType) => void;
};

export default function ServiceQuotationEditor(props: ServiceQuotationEditorProps) {
  const buildQuotationKey = (quotation: ProposalServiceQuotationType | null | undefined) =>
    quotation?.id || quotation?.idPropostaServicoCotacao?.toString() || quotation?.idTemporaria || '';

  return (
    <ServiceQuotationSummary
      data={props.data}
      isEdit={props.isEdit}
      sharedResidues={props.sharedResidues}
      referenceData={props.referenceData}
      zIndex={props.zIndex}
      onAdd={() => undefined}
      onQuotationAction={() => undefined}
      onToleranceAction={() => undefined}
      onQuotationSubmit={(quotation) => {
        if (!props.onChange) {
          return;
        }

        if (!quotation) {
          return;
        }

        const targetKey = buildQuotationKey(quotation);
        const quotationIndex = props.data.cotacoes.findIndex((item) => buildQuotationKey(item) === targetKey);

        if (quotationIndex > -1) {
          props.onChange({
            ...props.data,
            cotacoes: props.data.cotacoes.map((item, index) =>
              index === quotationIndex
                ? {
                    ...item,
                    ...quotation,
                  }
                : item
            ),
          });
          return;
        }

        props.onChange({
          ...props.data,
          cotacoes: [...props.data.cotacoes, quotation],
        });
      }}
      onSetPrimary={(quotation) => {
        if (!props.onChange) {
          return;
        }

        const targetKey = buildQuotationKey(quotation);

        props.onChange({
          ...props.data,
          cotacoes: props.data.cotacoes.map((item) => {
            if (item.action === Action.Delete) {
              return item;
            }

            const isTarget = buildQuotationKey(item) === targetKey;
            let nextAction = item.action || Action.Nothing;

            if (item.primario !== isTarget && nextAction === Action.Nothing) {
              nextAction = Action.Modify;
            }

            return {
              ...item,
              primario: isTarget,
              action: nextAction,
            };
          }),
        });
      }}
      onDeleteQuotation={(quotation) => {
        if (!props.onChange) {
          return;
        }

        const targetKey = buildQuotationKey(quotation);

        props.onChange({
          ...props.data,
          cotacoes: props.data.cotacoes
            .map((item) => {
              if (buildQuotationKey(item) !== targetKey) {
                return item;
              }

              return {
                ...item,
                action: Action.Delete,
              };
            })
            .filter((item) => !(buildQuotationKey(item) === targetKey && !item.idPropostaServicoCotacao)),
        });
      }}
      initialQuotationItem={props.initialQuotationItem || null}
      initialQuotationTab={props.initialQuotationTab || 'Cotacao'}
      autoOpenQuotationModal={props.autoOpenQuotationModal || false}
    />
  );
}
